import React, { useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingButton({ onClickPromise, onClick, disabled, children, startIcon, ...restProps }) {
  const [isLoading, setIsLoading] = useState(false);

  const onClickButton = useCallback((e) => {
    if ( onClickPromise ) {
      setIsLoading(true);
      // if it is a promise, wait for it to resolve
      onClickPromise(e).finally(() => setIsLoading(false));
    }
    else {
      onClick(e);
    }
  }, [onClickPromise, onClick]);

  return (
    <Button
      {...restProps}
      onClick={onClickButton}
      disabled={disabled || isLoading}
      startIcon={
        isLoading
          ? <CircularProgress color="info" size={20} thickness={3}/>
          : startIcon
      }
    >
      {children}
    </Button>
  );
};
